// update version on symptom id edit or remove
export const VERSION = 1;

// don't touch these
export const cloudName = "dta443kr0";
export const uploadPreset = "orda-cloud";
